module.exports = __webpack_public_path__ + "static/media/sliderImg3.d12943aa.png";